module.exports = __webpack_public_path__ + "img/course73_summary_unit_timelines.f75c30cf.png";